module.exports = __webpack_public_path__ + "img/pr-5.63690a46.png";